import ApplicationSerializer from 'uplisting-frontend/serializers/application';

export default class BookingDotComHotelPublicationSerializer extends ApplicationSerializer {
  shouldSerializeHasMany() {
    return true;
  }
}

declare module 'ember-data/types/registries/serializer' {
  interface SerializerRegistry {
    'booking-dot-com-hotel-publication': BookingDotComHotelPublicationSerializer;
  }
}
